const lunr = require('lunr')
require('lunr-languages/lunr.stemmer.support')(lunr)
require('lunr-languages/lunr.multi')(lunr)
require('./lunr.ko')(lunr)

// custom lunr with korean support
module.exports = lunr
